export const FUNNEL_SIGNUP_MAIN = {
  name: "signup-main-step-name",
  address: "signup-main-step-address",
  family: "signup-main-step-family",
  category: "signup-main-step-category",
  check: "signup-main-step-check",
  employees: "signup-main-step-employees",
  identity: "signup-main-step-identity",
  phone: "signup-main-step-phone",
  password: "signup-main-step-password",
  origin: "signup-main-step-origin",
};

export const FUNNEL_SIGNUP_INFO = {
  seats: "signup-info-step-seats",
  description: "signup-info-step-description",
  photo: "signup-info-step-photo",
  cropper: "signup-info-step-cropper",
};

export const FUNNEL_SIGNUP_INFO_ALT = {
  description: "signup-info-alt-step-description",
  photo: "signup-info-alt-step-photo",
  cropper: "signup-info-alt-step-cropper",
};
